var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell",class:_vm.status.isAlive ? 'alive' : 'dead',style:(_vm.userColorStyle),on:{"click":function($event){return _vm.reborn(true)},"pointerover":function($event){return _vm.reborn(_vm.isPointerDown)}}})}
var staticRenderFns = []

export { render, staticRenderFns }